import React, { useContext, useMemo } from 'react';
import BreakpointContext from '../../contexts/BreakpointContext';
import SwitchTestContext from '../../contexts/SwitchTestContext';
import ProductPageContext from '../../contexts/ProductPageContext';
import { checkHasShowStyliticsEnabled } from '../../helpers/styliticsUtils';
import Stylitics from './Stylitics';

export default function StyliticsContainer({
  swatchChanged,
}) {
  const breakpoints = useContext(BreakpointContext);
  const SwitchTestState = useContext(SwitchTestContext);
  const ProductPageState = useContext(ProductPageContext);

  const isMobile = breakpoints.xxsmall && !breakpoints.medium;
  const brand = ProductPageState.collectionData?.activeProduct?.brand;
  const kicId = ProductPageState.collectionData?.activeProduct?.kicId;
  const siteRegion = ProductPageState.collectionData?.siteRegion;
  const showStyliticsFromFeatureSwitch = SwitchTestState['pdp-hotspots-outfitting-solution'];
  const hasStyliticsQuickViewMfeFlag = SwitchTestState['quickview-mfe-product-stylitics'];

  const hasShowStyliticsEnabled = checkHasShowStyliticsEnabled(
    showStyliticsFromFeatureSwitch,
    brand,
    isMobile,
  );

  const styliticsComponent = useMemo(() => {
    if (!hasShowStyliticsEnabled) return null;

    return (
      <Stylitics
        kicId={kicId}
        brand={brand}
        tmntData={ProductPageState.tmntData}
        isMobile={isMobile}
        swatchChanged={swatchChanged}
        siteRegion={siteRegion}
        locale={ProductPageState.collectionData?.styliticsV3Locale}
        quickViewMfeFlag={hasStyliticsQuickViewMfeFlag}
      />
    );
  }, [
    hasShowStyliticsEnabled,
    kicId,
    brand,
    ProductPageState.tmntData,
    isMobile,
    swatchChanged,
    siteRegion,
    ProductPageState.collectionData?.styliticsV3Locale,
    hasStyliticsQuickViewMfeFlag,
  ]);

  return styliticsComponent;
}
